;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import * as Sentry from '@sentry/nextjs'
import React from 'react'
import { EMAILS } from 'src/core/constants/copy'
import { browserLogger } from 'src/core/logger/browser'
import { TopBar } from 'src/deprecated/components/shared/TopBar'

type ErrorBoundaryProps = {
  fallback: React.ReactNode
  children: React.ReactNode
}

type ErrorBoundaryState = {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    browserLogger.error(error)
    Sentry.captureException(error)
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return this.props.fallback
  }
}

export function DefaultErrorBoundaryFallback() {
  const supportLink = (
    <Anchor
      href={`mailto:${EMAILS.support}`}
      variant="inline-text"
      // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
      className="text-info-700 underline"
      hideProgressBar
    >
      {EMAILS.support}
    </Anchor>
  )

  return (
    <div className="flex min-h-screen flex-col">
      <TopBar />

      <main>
        <div className="mx-auto flex max-w-[54rem] flex-col items-center justify-center px-8 py-16 sm:flex-row">
          <div className="basis-4/5 text-center">
            <h2 className="pb-8 text-3xl">Oops, there is an error!</h2>

            <p className="pb-8">
              Please try again, return to home or contact {supportLink} if the
              issue continues
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
